<div class="journey-stages-component">
    <ng-container *ngIf="data !== null">
        <ng-container *ngFor="let journey of data.journeys">
            <div *ngIf="false" class="header-wrap content-wrap-inner compact">
                <h2>{{ "__COACH_JOURNEY__" | translate }}: {{journey.journey.name}}</h2>
            </div>
            <ng-container *ngFor="let stage of journey.stages">
                <div class="header-wrap content-wrap-inner compact">
                    <h2>{{ "__COACH_JOURNEY__" | translate }}: {{journey.journey.name}}</h2>
                    <h3>{{ "__COACH_STAGE__" | translate }}: <span class="my-color-blue">{{stage.info.title}}</span></h3>
                </div>

                <div class="program-wrap" *ngIf="stage.info.type === 'program'">
                    <app-journey-list-template-course-title
                            [programDelegate]="stage.details.program_delegate"></app-journey-list-template-course-title>
                </div>
                <div class="list-wrap" *ngIf="stage.info.type === 'list' && stage.details.tasks.length">
                    <!--div class="line-text content-wrap-inner" *ngIf="stage.details.tasks.length" [@enter] [innerHTML]="('__TEAM_DETAILS_DESC1__' | translate)"></div-->
                    <div class="list">
                        <ng-container *ngFor="let item of stage.details.tasks; let i = index">
                            <ng-container *ngIf="item.section !== 'course_title' && (item.for_coach || item.public_coach)">
                                <div class="line line-empty content-wrap-inner compact" *ngIf="false && item.section !== 'course_title' && i===0"></div>
                                <div class="line" [ngClass]="{'content-wrap-inner compact': item.section !== 'course_title'}" [@leave]>
                                    <app-journey-list-template-checkbox
                                            *ngIf="['custom_textbox', 'roi', 'course_title', 'html'].indexOf(item.section) < 0 && !item.for_coach"
                                            [ngClass]="{disabled: item.section !== 'file' || !item.details.file.url }" [disabled]="true" [task]="item" [for_coach]="true"></app-journey-list-template-checkbox>

                                    <app-journey-list-template-checkbox
                                            *ngIf="['custom_textbox', 'html'].indexOf(item.section) < 0 && item.for_coach"
                                            [task]="item" [for_coach]="true" [disabled]="true"></app-journey-list-template-checkbox>

                                    <app-list-dropdown *ngIf="item.section === 'custom_textbox' && !item.for_coach" [title]="item.title_for_coach">
                                        <app-journey-list-template-textarea
                                                [task]="item" [readonly]="true" [embedded]="true" [for_coach]="true"></app-journey-list-template-textarea>
                                    </app-list-dropdown>

                                    <app-journey-list-template-textarea
                                            *ngIf="item.section === 'custom_textbox' && item.for_coach"
                                            [task]="item" [for_coach]="true" [readonly]="true" [embedded]="true"
                                            (doChange)="onFormChange($event)"></app-journey-list-template-textarea>

                                    <app-list-dropdown *ngIf="item.section === 'roi' && !item.for_coach" [title]="item.title_for_coach">
                                        <app-journey-list-template-financial
                                                [task]="item" [readonly]="true" [embedded]="true" [for_coach]="true"></app-journey-list-template-financial>
                                    </app-list-dropdown>

                                    <app-journey-list-template-course-title *ngIf="item.section === 'course_title'"
                                                                            [programDelegate]="item.details.program_delegate" [for_coach]="true"></app-journey-list-template-course-title>

                                    <app-journey-list-template-html *ngIf="item.section === 'html' && (item.for_coach || item.public_coach)"
                                                                    [disabled]="!item.for_coach"
                                                                    [task]="item" [title]="item.title_for_coach" [html]="item.text_for_coach"></app-journey-list-template-html>
                                </div>
                                <!--div class="line-text content-wrap-inner" *ngIf="item.section === 'course_title' && stage.details.tasks.length > i + 1" [@enter] [innerHTML]="('__TEAM_DETAILS_DESC1__' | translate)"></div-->
                                <div class="line line-empty content-wrap-inner compact" *ngIf="item.section === 'course_title'"></div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
